import { mapSeries } from "@/api/mapping/series";

export default function ($api) {
    return {
        /**
         * Получить список всех серий для сайта
         * @param  { String } categoryId - идентификатор категории
         * @returns { Array } - Список серий
         */
        getAll(categoryId) {
            const type = categoryId ? "bySections" : "all";
            const categoryFilter =
                categoryId !== "0" ? `&filters[categoriesIds][eq]=${categoryId}` : "";
            return $api
                .get(`api/series/${type}?sorts[sort]=asc${categoryFilter}`)
                .then(mapSeries);
        },
    };
}
